import { defineOperationManifest } from "../define"

export const translateProductsManifest = defineOperationManifest({
	type: "translate.products",
	ability: "ai.translate-products",
	bocLabelKey: "operations.boc.types.translateProducts",
	skipUsageRecording: true,
})
